import type { FaireProductEntity } from "../../entity_types/product";

export const p_wahgcz8hij: FaireProductEntity = {
  token: "p_wahgcz8hij",
  type: "product",
  name: "Custom Cosmetic Bag (Your Logo / Your Own Design)",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/ed5401cd49b8579a8a8d043f910b2422c3188e13d3df494858fd5e5cdc6f79a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/466a464b5f1ed997772461886cf0e442f31eed6709b6a17cb1e093207f141817.jpeg",
    "https://cdn.faire.com/fastly/899d47b132b33c2c358d27dcd0483f8941d76b713175882852c13d8019f3e1de.jpeg",
    "https://cdn.faire.com/fastly/1bb297fc364c5360d33d2d06a25398e16630ff45660fe886aefeeb8268c3a0fa.jpeg"
  ],
  priceDollars: 10,
  description: "Customize this item with your artwork, logo or design!\n\nSimply submit your artwork and we'll print it for you! We kindly request the artwork to be in high resolution format. A PDF, EPS, PSD, or AI file is required to ensure the print is sharp and not pixelated. JPGs above 1000 pixels can be accepted.\nOur cotton canvas cosmetic bags make the perfect everyday pouch! Great for travel, these makeup bags can not only be filled with cosmetics but can serve as a carrying case for your headphones, cell phone, sunglasses, and keys.\nThese custom pouches make the perfect gifts for the holidays, corporate events, client thank yous, birthdays, weddings and many more!\n\nTo purchase, kindly place your order and message us your artwork.\n\nA proof available upon request.\n\n• Material: 100% Cotton Canvas Fabric\n• Heavy duty cotton canvas fabric\n• High quality gold zipper\n• Size: 9\" W x 6\" H\n• Reusable and Eco-friendly\n• Designed and printed in the USA\n• All personalized item sales are final.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:44.915Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
